<script setup lang="ts">
/* eslint-disable max-len */
export interface IconHighlightProps {
  width?: number;
  height?: number;
  fill?: string;
}

const props = withDefaults(defineProps<IconHighlightProps>(), {
  width: 10,
  height: 10,
  fill: "#A9B7D1",
});
</script>

<template>
  <svg :width="props.width" :height="props.height" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 8 8">
    <path :fill="props.fill" fill-rule="evenodd" d="M2.807 4.179c.042 0 .076.025.084.066a2.07 2.07 0 0 0 1.627 1.6.08.08 0 0 1 .068.082.08.08 0 0 1-.068.082 2.072 2.072 0 0 0-1.627 1.592c-.008.04-.042.066-.084.066s-.076-.025-.084-.066a2.072 2.072 0 0 0-1.627-1.592.08.08 0 0 1-.068-.082.08.08 0 0 1 .068-.083 2.07 2.07 0 0 0 1.627-1.599c.008-.041.042-.066.084-.066zM5.783 1.45c.059 0 .101.033.11.082A2.58 2.58 0 0 0 7.916 3.52c.05.009.084.05.084.108 0 .057-.034.099-.084.107-1.012.206-1.813.981-2.023 1.979a.116.116 0 0 1-.11.082c-.06 0-.101-.033-.11-.082a2.582 2.582 0 0 0-2.023-1.98c-.05-.016-.084-.057-.084-.106 0-.058.034-.1.084-.108a2.592 2.592 0 0 0 2.023-1.987.116.116 0 0 1 .11-.082zM1.72.667c.05 0 .1.033.11.082.176.742.766 1.32 1.525 1.5.05.009.084.058.084.108 0 .05-.033.09-.084.107-.742.173-1.349.759-1.526 1.492-.008.05-.059.083-.11.083a.116.116 0 0 1-.109-.083A2.07 2.07 0 0 0 .084 2.464C.034 2.456 0 2.406 0 2.357c0-.05.034-.09.084-.107A2.055 2.055 0 0 0 1.61.75c.009-.05.06-.083.11-.083z" />
  </svg>
</template>
